import AmasaStaking from '../../components/amasa-staking/amasa-staking';
import LiquidityMining from '../../components/liquidity-mining/liquidity-mining';
import StakingDialog from '../../components/staking-dialog/staking-dialog';
import React from 'react';
import {StakingType} from "../../services/LiquidyMiningService";

function Staking() {
    const [stakingDialogOpen, setStakingDialogOpen] = React.useState(false);
    const [dialogData, setDialogData] = React.useState({name: '', balance: 0});

    const handleStakingDialogOpen = (data: any) => {
        setDialogData(data);
        setStakingDialogOpen(true);
    };

    const handleStakingDialogClose = () => {
        setStakingDialogOpen(false);
    };

    const handleSetDialogData = (data: any) => {
        setDialogData(data);
    };

    const getCurrentStaking = () => {
        return dialogData.name;
    };

    return (
        <>
            <StakingDialog
                open={stakingDialogOpen}
                data={dialogData}
                handleStakingDialogOpen={handleStakingDialogOpen}
                handleStakingDialogClose={handleStakingDialogClose}
            />
            <div className="contents">
                <AmasaStaking handleSetDialogData={handleSetDialogData}
                              title={'$AMAS Staking - Round 1 (ended)'}
                              stakingType={StakingType.FIRST}
                              handleStakingDialogOpen={handleStakingDialogOpen} getCurrentStaking={getCurrentStaking}/>
                <AmasaStaking handleSetDialogData={handleSetDialogData}
                              title={'$AMAS Staking - Round 2 (opens Feb 7)'}
                              stakingType={StakingType.SECOND}
                              handleStakingDialogOpen={handleStakingDialogOpen} getCurrentStaking={getCurrentStaking}/>

            </div>
            <div className="secondLiquidity">
                <div>
                    <LiquidityMining handleSetDialogData={handleSetDialogData}
                                     handleStakingDialogOpen={handleStakingDialogOpen}
                                     title={'AMAS:ETH Uniswap v2 LP Token Staking (ended)'}
                                     stakingType={StakingType.FIRST}
                                     getCurrentStaking={getCurrentStaking}/>
                </div>
            </div>

        </>
    );
}

export default Staking;
